import LocalStorageConstant from "../../constants/localstroage.constant";
import Helpers from "../../utils/helpers";

/** Fired when `access-token` in localStorage is updated so the app shell can re-sync (e.g. after async refresh). */
export const ACCESS_TOKEN_CHANGED_EVENT = "aura-access-token-changed";

const notifyAccessTokenChanged = () => {
    if (typeof window === "undefined") return;
    window.dispatchEvent(new CustomEvent(ACCESS_TOKEN_CHANGED_EVENT));
};

const getLocalRefreshToken = () => {
    return localStorage.getItem(LocalStorageConstant.refreshToken);
};

const getLocalAccessToken = () => {
    return localStorage.getItem(LocalStorageConstant.accessToken);
};

/**
 * Persists `at` from the current URL (OAuth callback) then returns the stored access token.
 * Call during initial render so parent shells (e.g. App) see a token before child effects run.
 */
const bootstrapAccessTokenFromUrl = (): string | null => {
    if (typeof window === "undefined") return null;
    try {
        const at = new URLSearchParams(window.location.search).get("at");
        if (at) {
            addOrUpdateLocalAccessToken(at);
            return at;
        }
    } catch {
        /* ignore malformed URL */
    }
    return getLocalAccessToken();
};

const addOrUpdateLocalAccessToken = (token: string) => {
    localStorage.setItem(LocalStorageConstant.accessToken, token);
    notifyAccessTokenChanged();
};

const addOrUpdateLocalRefreshToken = (token: string) => {
    localStorage.setItem(LocalStorageConstant.refreshToken, token);
};

const getUser = () => {
    let user: string | null = localStorage.getItem(LocalStorageConstant.user);
    return user ? JSON.parse(user) : null;
};

const setUser = (user: any) => {
    Helpers.ConsoleLog(JSON.stringify(user));
    localStorage.setItem(LocalStorageConstant.user, JSON.stringify(user) ?? '');
};

const removeUser = () => {
    localStorage.removeItem(LocalStorageConstant.user);
};

const TokenService = {
    getLocalRefreshToken,
    getLocalAccessToken,
    bootstrapAccessTokenFromUrl,
    addOrUpdateLocalAccessToken,
    notifyAccessTokenChanged,
    addOrUpdateLocalRefreshToken,
    getUser,
    setUser,
    removeUser
};

export default TokenService;